module.exports = __webpack_public_path__ + "img/part2.a700f14a.jpg";